
import {Vue, Component, Prop} from 'vue-property-decorator'

@Component({
  name: 'SplitBillHeaderCard'
})
export default class SplitBillHeaderCard extends Vue {

  @Prop({required: true})
  name!: string

  @Prop({required: true})
  loading!: boolean;

  @Prop({required: false, default: undefined})
  width?: number

  @Prop({required: false})
  tooltip!: string

  get cardStyle() {
    if (this.width) {
      return {width: this.width + 'px'}
    } else {
      return {}
    }
  }

}
